import React from 'react';
import { UiSummaryCard, UiSummaryCards } from '../../components/ui/UiSummaryCard';

// Inventory report tab — extracted from Reports.js. Presentational; data/handlers via ctx.
export default function InventoryReport(ctx) {
  const { data, formatCurrency, openDrillDown } = ctx;
  return (
    <div className="space-y-6">
      {/* Summary */}
      <UiSummaryCards>
        <UiSummaryCard label="Total Items" value={data?.summary?.total_items || 0} />
        <UiSummaryCard label="Total Value" value={formatCurrency(data?.summary?.total_value)} tone="text-primary-600" />
        <UiSummaryCard label="Low Stock" value={data?.summary?.low_stock_count || 0} tone="text-red-600" />
        <UiSummaryCard label="Expiring" value={data?.summary?.expiring_count || 0} tone="text-orange-600" />
      </UiSummaryCards>

      {/* Inventory Table */}
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-3 sm:px-4 py-3 text-left text-xs sm:text-sm font-medium text-gray-600">Item</th>
              <th className="px-3 sm:px-4 py-3 text-left text-xs sm:text-sm font-medium text-gray-600 hidden sm:table-cell">Quantity</th>
              <th className="px-3 sm:px-4 py-3 text-left text-xs sm:text-sm font-medium text-gray-600 hidden sm:table-cell">Unit Price</th>
              <th className="px-3 sm:px-4 py-3 text-right text-xs sm:text-sm font-medium text-gray-600">Value</th>
              <th className="px-3 sm:px-4 py-3 text-left text-xs sm:text-sm font-medium text-gray-600">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {(data?.all_items || []).map((item) => (
              <tr
                key={item.id}
                className="hover:bg-orange-50 cursor-pointer transition"
                onClick={() => openDrillDown('inventory_purchase_history', { raw_material_id: item.id }, `Inventory Purchases: ${item.name}`)}
              >
                <td className="px-3 sm:px-4 py-3">
                  <p className="font-medium">{item.name}</p>
                  <p className="text-xs text-gray-500 sm:hidden">{item.quantity} {item.unit_abbr}</p>
                </td>
                <td className="px-3 sm:px-4 py-3 hidden sm:table-cell">{item.quantity} {item.unit_abbr}</td>
                <td className="px-3 sm:px-4 py-3 hidden sm:table-cell">{formatCurrency(item.purchase_price)}</td>
                <td className="px-3 sm:px-4 py-3 text-right font-medium">{formatCurrency(parseFloat(item.quantity) * parseFloat(item.purchase_price))}</td>
                <td className="px-3 sm:px-4 py-3">
                  <span className={`px-2 py-1 text-xs rounded-full ${item.is_low_stock ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                    {item.is_low_stock ? 'Low Stock' : 'OK'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
